module.exports = __webpack_public_path__ + "static/media/ROCAS.7d1e61e1.png";